export const getFundStats = token =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-fund-stats`, {
    method: 'GET',
    headers: {
      token,
    },
  })
